module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [(!_vm.useUniquePrice) ? _c('product-price', {
    attrs: {
      "input": _vm.variation.price,
      "block": _vm.disabledInputs,
      "module": _vm.fromModule,
      "sku": _vm.variation.sku
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-3@md"
  }, [_c('form-group', {
    attrs: {
      "label": "Redutor",
      "columns": 12,
      "error": _vm.getError('stock.reducer', _vm.variation.sku),
      "required": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.variation.stock.reducer),
      expression: "variation.stock.reducer"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.disabledInputs
    },
    domProps: {
      "value": (_vm.variation.stock.reducer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.variation.stock, "reducer", $event.target.value)
      }
    }
  })])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0dbc9494","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/mercadoLivre/announcement/variation/VariationAttributes.vue
// module id = 2903
// module chunks = 0